import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=367654b5&"
import script from "./GamesList.vue?vue&type=script&lang=js&"
export * from "./GamesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports